/* @flow */

import React from 'react';

import SellerDashboardComponent from 'app/sellers/dashboard';
import WebsiteDashboardPageComponent from 'components/websiteStructure/pages/dashboard';
import { useSelector } from 'react-redux';

export default function SellerDashboardPage() {

  const { isSupplier } = useSelector(state => ({isSupplier: state.auth.user.activeCompany.isSupplier }))

  return (
    <WebsiteDashboardPageComponent id="seller.dashboard.title" hideTitle={isSupplier}>
      <SellerDashboardComponent />
    </WebsiteDashboardPageComponent>
  );
}
